<p-dialog
  header="Parámetros Técnicos"
  [(visible)]="visible"
  (onHide)="onDialogHide()"
  [style]="{ width: '800px', maxHeight: '80vh', height: '100%' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [modal]="true"
  [closable]="true"
  styleClass="technical-parameters-container"
>
  <div class="technical-parameters-container">
    <!-- Sección de filtros -->
    <div class="filters-section">
      <!-- Filtros compactos en una sola fila -->
      <div
        class="compact-filters-row"
        [ngClass]="{ 'with-advanced-filters': showAdvancedFilters }"
      >
        <!-- Icono de expansión -->
        <button
          type="button"
          class="expand-toggle-btn"
          (click)="toggleAdvancedFilters()"
          title="{{
            showAdvancedFilters
              ? 'Ocultar filtros avanzados'
              : 'Mostrar filtros avanzados'
          }}"
        >
          <i
            class="pi pi-chevron-down"
            [ngClass]="{ rotated: showAdvancedFilters }"
          ></i>
        </button>

        <!-- Búsqueda general -->
        <div class="search-input-compact">
          <i class="pi pi-search search-icon"></i>
          <input
            type="text"
            class="search-field-compact"
            placeholder="Buscar por key, valor o número de trama..."
            [formControl]="searchControl"
            (keyup)="applyFilters()"
          />
          <i
            class="pi pi-times clear-search"
            *ngIf="searchControl.value"
            (click)="clearSearch()"
            title="Limpiar búsqueda"
          ></i>
        </div>

        <!-- Filtro por tipo de key compacto -->
        <div class="parameter-type-compact">
          <p-dropdown
            [options]="availableKeyTypesFormatted"
            [formControl]="keyTypeControl"
            placeholder="Todos los tipos"
            [showClear]="false"
            styleClass="key-type-dropdown-compact"
            optionLabel="label"
            optionValue="value"
          >
          </p-dropdown>
        </div>

        <!-- Botón limpiar filtros como icono -->
        <button
          type="button"
          class="clear-filters-icon-btn"
          (click)="clearFilters()"
          title="Limpiar todos los filtros"
        >
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>

      <!-- Filtros avanzados (colapsables) -->
      <div
        class="advanced-filters"
        [ngClass]="{ expanded: showAdvancedFilters }"
      >
        <!-- Número de tramo/serie -->
        <div class="filters-row">
          <div class="filter-group">
            <label>Número de tramo/serie</label>
            <input
              type="number"
              class="number-input"
              placeholder="Ingrese número de tramo..."
              [formControl]="frameNumberControl"
              min="1"
            />
          </div>

          <!-- Búsqueda específica por tipo -->
          <div class="filter-group">
            <label>Tipo específico</label>
            <input
              type="text"
              class="text-input"
              placeholder="Buscar tipo específico..."
              [formControl]="specificTypeControl"
            />
          </div>

          <!-- Búsqueda específica por valor -->
          <div class="filter-group">
            <label>Valor específico</label>
            <input
              type="text"
              class="text-input"
              placeholder="Buscar valor específico..."
              [formControl]="specificValueControl"
            />
          </div>
        </div>

        <!-- Fila de filtros de fecha -->
        <div class="date-filters-row">
          <!-- Fecha específica -->
          <div class="filter-group">
            <label>Fecha específica</label>
            <input
              type="date"
              class="date-input"
              [formControl]="specificDateControl"
            />
          </div>

          <!-- Hora inicio -->
          <div class="filter-group">
            <label>Hora inicio</label>
            <p-calendar
              [formControl]="startTimeControl"
              [timeOnly]="true"
              [showIcon]="true"
              icon="pi pi-clock"
              [appendTo]="'body'"
              [showSeconds]="true"
              hourFormat="24"
              placeholder="HH:MM:SS"
              [disabled]="!specificDateControl.value"
              styleClass="time-calendar"
            ></p-calendar>
          </div>

          <!-- Hora fin -->
          <div class="filter-group">
            <label>Hora fin</label>
            <p-calendar
              [formControl]="endTimeControl"
              [timeOnly]="true"
              [showIcon]="true"
              icon="pi pi-clock"
              [appendTo]="'body'"
              [showSeconds]="true"
              hourFormat="24"
              placeholder="HH:MM:SS"
              [disabled]="!specificDateControl.value"
              styleClass="time-calendar"
            ></p-calendar>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de parámetros con virtual scroll -->
    <div class="parameters-section">
      <div class="parameters-header">
        <div class="header-cell key-column">Parámetro</div>
        <div class="header-cell value-column">Valor</div>
        <div class="header-cell timestamp-column">Fecha y Hora</div>
        <div class="header-cell frame-column">Trama #</div>
      </div>

      <!-- el 162.05px es la medida de la parte de filtros -->
      <!-- el 43.88px es la medida de la parte de header de la tabla -->

      <cdk-virtual-scroll-viewport
        #virtualScroll
        [itemSize]="itemSize"
        class="parameters-viewport"
      >
        <div
          *cdkVirtualFor="
            let parameter of filteredParameters;
            trackBy: trackByParameter
          "
          class="parameter-row"
        >
          <div class="parameter-cell key-column">
            <span class="parameter-key">{{ parameter.key }}</span>
          </div>

          <div class="parameter-cell value-column">
            <span class="parameter-value" [title]="parameter.displayValue">
              {{ parameter.displayValue }}
            </span>
          </div>

          <div class="parameter-cell timestamp-column">
            <span class="parameter-timestamp">
              {{ parameter.timestamp | date : "dd/MM/yyyy HH:mm:ss" }}
            </span>
          </div>

          <div class="parameter-cell frame-column">
            <span class="parameter-frame">
              {{ parameter.frameIndex + 1 }}
            </span>
          </div>
        </div>

        <!-- Estado vacío -->
        <div *ngIf="filteredParameters.length === 0" class="empty-state">
          <div class="empty-content">
            <i class="pi pi-info-circle empty-icon"></i>
            <h3>No se encontraron parámetros</h3>
            <p>Intenta ajustar los filtros para ver más resultados</p>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <!-- Información de parámetros encontrados -->
    <div class="results-info-section">
      <div class="results-count">
        <span>{{ filteredParameters.length }} parámetros encontrados</span>
      </div>
    </div>
  </div>
</p-dialog>
